module.exports = __webpack_public_path__ + "img/9788932917269.52cb9f69.jpg";